module.exports = __webpack_public_path__ + "static/media/Omong-omong.2dafb275.PNG";